function officeUserProfile(): Office.UserProfile {
  return Office.context.mailbox.userProfile || ({} as Office.UserProfile)
}

function officeInitialData() {
  // @ts-ignore
  return Office.context.mailbox.initialData || {}
}

export function officeUsername(): string {
  return officeUserProfile().emailAddress || officeInitialData().userEmailAddress || ''
}

export function officeDisplayName(): string {
  return officeInitialData().displayName || officeInitialData().userDisplayName || ''
}

export function officeTimeZone(): string {
  return officeUserProfile().timeZone || ''
}

export function officeAccountType(): string {
  return officeUserProfile().accountType || ''
}

const exportFunctions = {
  username: officeUsername,
  displayName: officeDisplayName,
  timezone: officeTimeZone,
  accountType: officeAccountType,
}

export default exportFunctions
